module.exports = __webpack_public_path__ + "assets/Retina-Black.bab091ef1ca8294a8f426476ce543368.woff";